import React, { useEffect, useState } from 'react';
import { apiFetch } from "../../api/api";
import PrintAccounting from '../printManager/PrintAccounting';
import { printSelectedRecords, admissionMessage } from '../printManager/printAccountingApi';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import './RecordDrawer.css';

export default function RecordDrawer({
  record,
  schema,
  records,
  currentIndex,
  onSelectRecord,
  onClose,
  onSaved
}) {
  const printInFlight = useRef(false);
  const [printResults, setPrintResults] = useState([]);
  const [printRevision, setPrintRevision] = useState(0);
  const [printBusy, setPrintBusy] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editFields, setEditFields] = useState({});




  useEffect(() => {
    const handleKey =
      (e) => {
        if (
          e.key ===
          'ArrowLeft' &&
          currentIndex > 0
        ) {

          onSelectRecord(
            records[
              currentIndex - 1
            ]
          );

        }

        if (
          e.key ===
          'ArrowRight' &&
          currentIndex <
          records.length - 1
        ) {

          onSelectRecord(
            records[
              currentIndex + 1
            ]
          );

        }

      };

    window.addEventListener(
      'keydown',
      handleKey
    );

    return () =>
      window.removeEventListener(
        'keydown',
        handleKey
      );

  }, [
    currentIndex,
    records,
    onSelectRecord
  ]);


  useEffect(() => {

    if (!record) return;

    setEditFields(
      Object.fromEntries(
        Object.entries(
          record.fields || {}
        )
      )
    );

    setIsEditing(false);

  }, [record]);


  const handleSave = async () => {

    try {

      await toast.promise(

        apiFetch('/datadoc/updateFields', {
          method: 'POST',
          body: {
            dataDocId: record._id,
            fields: editFields
          }
        }),

        {
          pending: 'Saving...',
          success: 'Record saved.',
          error: 'Save failed.'
        }

      );

      if (onSaved) {
        await onSaved();
      }

      setIsEditing(false);

    } catch (err) {

      console.error(
        'Save failed',
        err
      );

    }

  };

  const handlePrint = async () => {
    if (printInFlight.current || !record?._id) return;
    printInFlight.current = true;
    setPrintBusy(true);
    try {
      const results = await printSelectedRecords([record._id], record.datasetId);
      setPrintResults(results);
      setPrintRevision(v => v + 1);
      // Keep the record open so admission and history remain reviewable.
    } finally { printInFlight.current = false; setPrintBusy(false); }
  };


  const handleReprocessRender = async () => {

    if (!record?._id) return;

    try {

      await toast.promise(

        apiFetch('/datadoc/reprocessRender', {
          method: 'POST',
          body: {
            dataDocId: record._id
          }
        }),

        {
          pending: 'Reprocessing image...',
          success: 'Image reprocess queued.',
          error: 'Reprocess failed.'
        }

      );

      if (onSaved) {
        await onSaved();
      }

    } catch (err) {

      console.error(
        'Reprocess failed',
        err
      );

    }

  };





  if (!record) {
    return null;
  }



  return (

    <div className="record-drawer-overlay">

      <div className="record-drawer">

      <div className="record-drawer-header">

        <div>

          <h3>
            {record.displayName ||
              'Data Record'}
          </h3>

          <div
            style={{
              marginTop:4,
              fontSize:12,
              color:'#666'
            }}
          >
            Record {currentIndex + 1}
            {' of '}
            {records.length}
          </div>

        </div>

        <div
          style={{
            display:'flex',
            gap:8
          }}
        >

          <button
            className="btn-gray"
            disabled={
              currentIndex <= 0
            }
            onClick={() =>
              onSelectRecord(
                records[
                  currentIndex - 1
                ]
              )
            }
          >
            ◀ Prev
          </button>

          <button
            className="btn-gray"
            disabled={
              currentIndex >=
              records.length - 1
            }
            onClick={() =>
              onSelectRecord(
                records[
                  currentIndex + 1
                ]
              )
            }
          >
            Next ▶
          </button>




          <button
            className="btn-green"
            onClick={handlePrint}
            disabled={printBusy}
          >
            Print
          </button>
          <button
            className="btn-gray"
            onClick={() =>
              setIsEditing(!isEditing)
            }
          >
            {isEditing ? 'Cancel' : 'Edit'}
          </button>

          {isEditing && (
            <button
              className="btn-green"
              onClick={handleSave}
            >
              Save
            </button>
          )}
          <button
            className="btn-gray"
            onClick={onClose}
          >
            Close
          </button>

        </div>

      </div>

        <div className="record-drawer-body">
          {printBusy && <p role="status">Sending print request...</p>}
          {printResults.filter(r => r.dataDocId === String(record._id).toLowerCase()).map(r => <p key={r.dataDocId} role="status">{admissionMessage(r)}</p>)}
          <PrintAccounting key={record._id} dataDocId={record._id} revision={printRevision}
            uncertainJobId={printResults.find(r => r.dataDocId === String(record._id).toLowerCase() && r.admissionState === 'uncertain')?.jobId} />

        {record.photoUrl && (

          <div className="record-field">

            <div className="record-field-label">
              Photo URL
            </div>

            <div
              className="record-field-value"
              style={{
                display: 'flex',
                gap: 8,
                alignItems: 'center',
                flexWrap: 'wrap'
              }}
            >

              <button
                className="btn-gray"
                onClick={() =>
                  window.open(
                    record.photoUrl,
                    '_blank'
                  )
                }
              >
                View Photo
              </button>

              <button
                className="btn-green"
                onClick={handleReprocessRender}
                disabled={!record.photoUrl}
                title="Rebuild rendered card from the original photo"
              >
                Reprocess Render
              </button>

            </div>

          </div>

        )}
        {record.outputUrl && (

          <div className="record-field">

            <div className="record-field-label">
              Output URL
            </div>

            <div className="record-field-value">
            <button
              className="btn-gray"
              onClick={() =>
                window.open(
                  record.outputUrl,
                  '_blank'
                )
              }
            >
              View Card
            </button>

            </div>

          </div>

        )}
          {schema?.fields?.map(field => (

            <div
              key={field.key}
              className="record-field"
            >

              <div
                className="record-field-label"
              >
                {field.label}
              </div>

              <div
                className="record-field-value"
              >

                {isEditing ? (

                  <input
                    type="text"
                    value={
                      editFields[field.key] || ''
                    }
                    onChange={(e) =>
                      setEditFields(prev => ({
                        ...prev,
                        [field.key]:
                          e.target.value
                      }))
                    }
                    style={{
                      width:'100%'
                    }}
                  />

                ) : (

                  record.fields?.[
                    field.key
                  ] || ''

                )}

              </div>

            </div>

          ))}

          <hr />

          <div
            className="record-field"
          >

            <div
              className="record-field-label"
            >
              Status
            </div>

            <div
              className="record-field-value"
            >
              {
                record.renderStatus ||
                'pending'
              }
            </div>

          </div>

          <div
            className="record-field"
          >

            <div
              className="record-field-label"
            >
              Created
            </div>

            <div
              className="record-field-value"
            >
              {
                record.createdAt
                  ? new Date(
                      record.createdAt
                    ).toLocaleString()
                  : ''
              }
            </div>

          </div>

          <div
            className="record-field"
          >

            <div
              className="record-field-label"
            >
              Updated
            </div>

            <div
              className="record-field-value"
            >
              {
                record.updatedAt
                  ? new Date(
                      record.updatedAt
                    ).toLocaleString()
                  : ''
              }
            </div>

          </div>

        </div>

      </div>

    </div>

  );

}
